/**
 * RTL (Right-to-Left) text detection utility.
 *
 * Provides helpers for detecting RTL scripts (Arabic, Hebrew, Farsi, etc.)
 * in text content. Used by the TinyMCE RTL auto-detect plugin and any
 * plain-text input that needs automatic direction detection.
 *
 * Shared between Relay Messenger and Message Builder.
 */

/**
 * Unicode ranges for characters that are strongly RTL:
 *   \u0591-\u07FF  — Hebrew, Arabic, Syriac, Thaana, N'Ko
 *   \uFB1D-\uFDFD  — Hebrew/Arabic Presentation Forms-A
 *   \uFE70-\uFEFC  — Arabic Presentation Forms-B
 */
const RTL_CHAR_REGEX = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;

/**
 * Returns true when {@link text} contains at least one RTL character.
 */
export function containsRtlText(text: string): boolean {
  return RTL_CHAR_REGEX.test(text);
}

/**
 * Returns `'rtl'` when {@link text} contains RTL characters, otherwise `'ltr'`.
 */
export function detectTextDirection(text: string): 'rtl' | 'ltr' {
  return containsRtlText(text) ? 'rtl' : 'ltr';
}
